import { DecimalPipe } from "@angular/common";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import {
  AlertController,
  ModalController,
  Platform,
  PopoverController,
} from "ionic-angular";
import { GoalOfCareStatus } from "models/patient-chart/goal-of-care";
import moment from "moment";
import { Observable } from "rxjs/Observable";
import { ISubscription } from "rxjs/Subscription";
import { AuthService } from "../../../../app/auth/auth.service";
import { AssessmentDataService } from "../../../../providers/asmt-data-service/asmt-data-service";
import { IDGDataService } from "../../../../providers/idg-data-service/idg-data-service";
import { ResourceManagementService } from "../../../../providers/resource-management/resource-management.service";
import { IntercardDataService } from "../intercard-data/intercard-data.service";

const dateTimeFormat = "MM/DD/YYYY HH:mm";

/**
 * Generated class for the ListCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "new-expandable-list-card",
  templateUrl: "new-expandable-list-card.html",
})
export class NewExpandableListCard implements OnInit, OnDestroy {
  @Input() assessmentId: string;
  @Input() sectionId: string;
  @Input() config;
  @Input() disabled: boolean = false;
  @Input() visitType: string = "";
  @Input() visitCompleted: boolean = false;

  id: string;
  name: string;
  componentId: string;
  label: string;
  access: string;
  tooltip: object;
  colHeaders: string[];
  expandableRowDetails: string[];
  conditionalFormatting: object;
  deltaFields: string[];
  rawData: any[] = [];
  dataRows: any[] = [];
  dummyRow: object;
  prevRow: {};
  declinable: boolean;
  editable: boolean = false;
  manualAdd: boolean = true;
  seeMore: boolean = true;
  seeMoreText: boolean = true;
  seeMoreLength: number = 0;
  moreActions: boolean = false;
  resourceManagementLookupCodes: Object = {};
  isPalliative1_5: boolean = false;

  allowExternalData: boolean = false;
  delta: {};

  dataPages: Array<object[]> = [];
  pageSize: number = 5;
  currentPage: number = 0;

  cardDepObs: Observable<any> = null;
  cardDepObsSubscription: ISubscription;

  bmiHeight;
  heightTimeout;
  credentials: string;
  palCredentials: string;
  newData: boolean = false;
  previousData: boolean = false;
  previousDataLabel: string = "previousAssessment";

  constructor(
    public modalCtrl: ModalController,
    public dataService: AssessmentDataService,
    public decimalPipe: DecimalPipe,
    public plt: Platform,
    private alertCtrl: AlertController,
    public translatePipe: TranslateService,
    public intercard: IntercardDataService,
    public popover: PopoverController,
    public resoruce: ResourceManagementService,
    public idgDataService: IDGDataService,
    private authSvc: AuthService
  ) {}

  ngOnInit(): void {
    this.id = this.config.id;
    this.name = this.config.cardName;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined
        ? this.config.label
        : this.config.cardName;
    this.access = this.config.access;
    this.tooltip = this.config.tooltip;
    this.colHeaders = this.config.data.listHeaders;
    this.expandableRowDetails = this.config.data.expandableRowDetails;
    this.conditionalFormatting = this.config.data.conditionalFormatting;
    this.deltaFields = this.config.data.deltaFields || [];
    this.declinable = this.config.declinable;
    this.moreActions = this.config.moreActions;

    if (this.config.data.previousDataLabel) {
      this.previousDataLabel = this.config.data.previousDataLabel;
    }

    if (this.config.seeMore) {
      this.seeMore = !this.config.seeMore;
      this.seeMoreLength = this.config.seeMoreLength;
    }

    if (this.config.addNewBtn === true) {
      this.config.onAddNew = this.onAddNew.bind(this);
    }

    if (this.config.editable) {
      this.editable = this.config.editable;
    }
    if (this.config.manualAdd !== undefined && this.config.manualAdd !== null) {
      this.manualAdd = this.config.manualAdd;
    }
    if (this.config.allowExternalData) {
      this.allowExternalData = this.config.allowExternalData;
    }

    this.dummyRow = { id: "" };
    let dummyData = {};
    for (let header of this.colHeaders) {
      dummyData[header] = "-";
    }
    this.dummyRow["values"] = dummyData;

    if (this.allowExternalData) {
      this.cardDepObs = this.intercard.register(this.name);
      this.cardDepObsSubscription = this.cardDepObs.subscribe((data) => {
        if (data === undefined) {
          return;
        } else if (data["declined"] === true || data["noChanges"] === true) {
          let accept = () => {
            let obj = {};
            if (data["declined"]) {
              obj["acceptedDecline"] = true;
            }
            if (data["noChanges"]) {
              obj["acceptedNoChanges"] = true;
            }
            this.intercard.emitData("declines", obj);
          };

          let reject = () => {
            let obj = {};
            if (data["declined"]) {
              obj["rejectedDeclined"] = true;
            }
            if (data["noChanges"]) {
              obj["rejectedNoChanges"] = true;
            }
            this.intercard.emitData("declines", obj);
          };

          this.presentListForm(
            { category: "patientDeclinedAssessment" },
            accept,
            reject
          );
          return;
        } else if (data["adls"] === true) {
          this.presentListForm({ category: "adlNeeds" });
          return;
        }

        let newData = {};
        for (let header of this.colHeaders) {
          if (data[header]) {
            newData[header] = data[header];
          }
        }

        this.addData(newData);
      });
    }

    const user = this.authSvc.getUser();
    if (user) {
      // const role = JSON.parse(user.profile.role);
      // const { userID } = role[0];
      // let credentials = "";

      this.idgDataService.getPersonByQbosId(user.userId).subscribe(
        (data) => {
          if (data.disciplines.length > 0) {
            this.credentials = data.disciplines.filter(
              (x) => x.qbosId === data.discipline
            )[0].name;
          }
        },
        (err) => console.log("Credentials Not Found", err)
      );
    }
  }

  private getCredentialsByLookupCode(lookupCode: string) {
    let lookupElement = this.resourceManagementLookupCodes[
      "CredentialType"
    ].find((lookupElement) => {
      return lookupElement.id.toString() == lookupCode;
    });
    return lookupElement ? lookupElement.description : "";
  }
  @Input()
  set palliativeCareToggle(isPalliative: boolean) {
    this.isPalliative1_5 = isPalliative;
    if (isPalliative) {
      const user = this.authSvc.getUser();
      if (user) {
        this.resoruce.getLookUpValues().subscribe((response) => {
          this.resourceManagementLookupCodes = response;
          // const role = JSON.parse(user.profile.role);
          // const { userID } = role[0];
          let credentials = "";
          this.resoruce.getProviderByExternalId(user.userId).subscribe((p) => {
            for (let i = 0; i < p.credentials.length; i++) {
              credentials +=
                this.getCredentialsByLookupCode(
                  p.credentials[i].type.toString()
                ) + " ";
            }
            this.palCredentials = credentials;
          });
        });
      }
    }
  }

  @Input()
  set data(incomingData: any) {
    if (incomingData) {
      // Call some service to load rows and prevRow
      this.dataRows = [];
      if (incomingData.data) {
        incomingData.data = this.getAssessmentGoalsOfCare(incomingData.data);
        this.rawData = incomingData.data;
        for (let data of incomingData.data) {
          let info = {
            id: data.id,
            seemore: this.seeMore,
            seemoretext: this.seeMoreText,
          };
          let values = this.parseDataRow(data);
          info["values"] = values;
          this.dataRows.push(info);
        }
      }

      this.updateDataPages();

      if (incomingData.previous) {
        let prevData = incomingData.previous;

        let prevInfo = this.parseDataRow(prevData);
        this.prevRow = prevInfo;
        this.prevRow["id"] = prevData.id;
      }
      this.updateDelta();
    }
  }

  public handleResolve(event, data) {
    let checked = event.checked;

    let payload = {
      notes: data.values.notes,
      subject: data.values.subject,
      assessmentId: data.values.assessmentId,
      discipline: data.values.discipline,
      credentials: data.values.credentials,
    };

    if (this.config.id == "CL010.290") {
      payload["status"] = checked
        ? GoalOfCareStatus.RESOLVED
        : GoalOfCareStatus.ACTIVE;
    }
    if (checked) {
      payload["resolvedAssessmentId"] = this.assessmentId;
    }

    this.dataService
      .editRecord(this.assessmentId, this.sectionId, this.id, data.id, payload)
      .subscribe();
  }

  rowHighlighted(col, value) {
    if (this.conditionalFormatting) {
      let formatting = this.conditionalFormatting[col];
      if (formatting) {
        if (
          formatting.type == "greaterThan" &&
          formatting.refValue !== undefined &&
          value > formatting.refValue
        ) {
          return true;
        }
      }
    }

    return false;
  }

  getPageNumber() {
    return this.currentPage + 1;
  }

  presentListForm(data?: object, accept?: Function, reject?: Function): void {
    let newConfig;
    try {
      newConfig = JSON.parse(JSON.stringify(this.config));
    } catch (e) {
      newConfig = this.config;
    }

    let config = { config: newConfig };

    if (this.config.addNewBtn === true) {
      config.config["onAddNew"] = this.onAddNew.bind(this);
    }

    if (data !== undefined) {
      config["data"] = data;
    }

    let listModal = this.modalCtrl.create("InputModalPage", config, {
      enableBackdropDismiss: false,
    });
    listModal.onDidDismiss((data) => {
      if (data !== undefined && data !== null) {
        this.addData(data);
        if (accept) {
          accept();
        }
      } else if (reject) {
        reject();
      }
    });
    listModal.present();
  }

  onAddNew(data: any) {
    this.addData(data);
  }

  updateDelta() {
    if (this.prevRow && this.dataRows[0]) {
      let deltaFields = this.deltaFields;
      let dataRows = this.dataRows;
      let prevRow = this.prevRow;
      this.delta = {};
      for (let header of this.colHeaders) {
        let diff: any = "-";

        if (deltaFields.indexOf(header) == -1) {
          this.delta[header] = diff;
          continue;
        }

        if (header == "date" && moment(dataRows[0].values[header])) {
          let end = moment(dataRows[0].values[header]);
          let start = moment(prevRow[header]);
          let duration = moment.duration(start.diff(end));
          diff = duration.humanize() + " ago";
        } else if (
          !isNaN(dataRows[0].values[header]) &&
          !isNaN(prevRow[header])
        ) {
          diff = dataRows[0].values[header] - prevRow[header];
          diff = parseFloat(this.decimalPipe.transform(diff, "1.0-2"));
          if (diff > 0) {
            diff = "+" + diff;
          }
        }
        this.delta[header] = diff;
      }
    }
  }

  flattenIncomingData(data: object): object {
    let flatData = {};
    for (let key of Object.keys(data)) {
      if (typeof data[key] == "object") {
        let innerObj = data[key];
        if (innerObj == undefined) {
          continue;
        }
      } else {
        flatData[key] = data[key];
      }
    }
    return flatData;
  }

  parseDataRow(data: object) {
    let values = {};

    let flatData = this.flattenIncomingData(data);
    for (let header of this.colHeaders) {
      let val = "-";
      if (flatData[header] || flatData[header] === 0) {
        if (header === "date") {
          flatData[header] = moment(flatData[header]).format(dateTimeFormat);
        }
        val = flatData[header];
      } else if (header === "createdBy") {
        flatData[header] = flatData["addedBy"];
        if (flatData["credentials"]) {
          flatData[header] = flatData[header] + " " + flatData["credentials"];
        }

        val = flatData[header];
      } else if (header === "resolve") {
        flatData[header] = flatData["status"]
          ? flatData["status"] == GoalOfCareStatus.RESOLVED
          : false;
        val = flatData[header];
      } else if (header === "discipline") {
        flatData[header] = flatData["discipline"]
          ? flatData["discipline"]
          : "-";
        val = flatData[header];
      }

      values[header] = val;
    }
    if (this.assessmentId.toString() !== flatData["assessmentId"].toString()) {
      this.previousData = true;
    }

    if (this.assessmentId.toString() === flatData["assessmentId"].toString()) {
      this.newData = true;
    }

    values["assessmentId"] = flatData["assessmentId"]
      ? flatData["assessmentId"].toString()
      : null;

    if (this.isPalliative1_5 && this.config.id == "CL010.290") {
      values["discipline"] = flatData["discipline"]
        ? flatData["discipline"].toString()
        : null;
      values["credentials"] = flatData["credentials"]
        ? flatData["credentials"].toString()
        : null;
      values["resolvedAssessmentId"] = flatData["resolvedAssessmentId"]
        ? flatData["resolvedAssessmentId"].toString()
        : null;
    }

    for (let header of this.expandableRowDetails) {
      values[header] = flatData[header];
    }
    values["expanded"] = false;
    return values;
  }

  addData(data: any): void {
    if (data) {
      if (this.assessmentId != null) {
        try {
          data["assessmentId"] = this.assessmentId;
          data["discipline"] = this.credentials;
          if (this.config.id == "CL010.290" && this.isPalliative1_5) {
            data["credentials"] = this.palCredentials;
            data["status"] = GoalOfCareStatus.ACTIVE;
          }

          this.dataService
            .storeRecord(
              this.assessmentId,
              this.sectionId,
              this.id,
              data,
              this.label
            )
            .subscribe((returnData) => {
              if (!returnData) {
                return;
              }
              let newData = {
                id: returnData.id,
                seemore: this.seeMore,
                seemoretext: this.seeMoreText,
              };

              this.newData = true;
              newData["values"] = this.parseDataRow(returnData);

              this.rawData.unshift(returnData);
              this.dataRows.unshift(newData);
              this.updateDataPages();
              this.updateDelta();
            });
        } catch (error) {
          //console.log( "Error during data submission and building.", error );
        }
      }
    }
  }

  getAssessmentGoalsOfCare(goalsOfCare: Array<Object>) {
    return goalsOfCare.filter((goalOfCare: Object) => {
      if (!goalOfCare["assessmentId"] || !goalOfCare["resolvedAssessmentId"]) {
        return true;
      }

      return (
        parseInt(goalOfCare["assessmentId"]) <= parseInt(this.assessmentId) &&
        parseInt(this.assessmentId) <=
          parseInt(goalOfCare["resolvedAssessmentId"])
      );
    });
  }

  editRow(row: object): void {
    let modalConfig: any = {};
    try {
      modalConfig = JSON.parse(JSON.stringify({ config: this.config }));
    } catch (e) {
      modalConfig = { config: this.config };
    }
    // In case of Edit list item we don't need "Add New" button
    if (modalConfig.config.addNewBtn) {
      delete modalConfig.config.addNewBtn;
    }

    let values = this.rawData.filter((record) => record.id == row["id"])[0];
    if (values !== null || values !== undefined) {
      let inputKeys = Object.keys(this.config.inputs);
      let editData = {};

      for (let key of inputKeys) {
        if (values[key]) {
          if (key === "issueType") {
            values[key] = this.translatePipe.instant(values[key]);
          }
          editData[key] = values[key];
        } else {
          editData[key] = null;
        }
      }
      modalConfig["data"] = editData;
    }

    let listModal = this.modalCtrl.create("InputModalPage", modalConfig, {
      enableBackdropDismiss: false,
    });
    listModal.onDidDismiss((data) => {
      if (data !== undefined) {
        this.editData(row, row["id"], data);
      }
    });
    listModal.present();
  }

  moreOptions(ev: any, row: any) {
    let hideDeleteOption = false;
    const popover = this.popover.create(
      "CareTeamsOptionsPage",
      { hideDeleteOption },
      { cssClass: "care-teams-options-popover" }
    );
    popover.onDidDismiss((data) => {
      if (data) {
        if (data === "delete") {
          this.deleteRow(row.id);
        } else if (data === "edit") {
          this.editRow(row);
        }
      }
    });
    popover.present({ ev });
  }

  editData(
    oldRow: object,
    rowId: string,
    data: any,
    caller = "don't care"
  ): void {
    if (data) {
      try {
        data["assessmentId"] = this.assessmentId;
        data["discipline"] = this.credentials;
        if (this.config.id == "CL010.290" && this.isPalliative1_5) {
          data["credentials"] = this.palCredentials;
          data["status"] = GoalOfCareStatus.ACTIVE;
        }
        this.dataService
          .editRecord(this.assessmentId, this.sectionId, this.id, rowId, data)
          .subscribe((returnData) => {
            let newData = {
              id: returnData.id,
              seemore: this.seeMore,
              seemoretext: this.seeMoreText,
            };
            this.newData = true;
            newData["values"] = this.parseDataRow(returnData);

            let rawData = this.rawData;
            for (let index in rawData) {
              if (rawData[index]["id"] === returnData.id) {
                rawData[index] = returnData;
                break;
              }
            }

            this.dataRows.splice(this.dataRows.indexOf(oldRow), 1, newData);
            this.updateDataPages();
            this.updateDelta();
          });
      } catch (error) {
        console.log("Error during data submission and building.", error);
      }
    }
  }

  deleteRow(id: string) {
    let alert = this.alertCtrl.create({
      title: this.translatePipe.instant("confirmDeleteRecord"),
      buttons: [
        {
          text: "Cancel",
        },
        {
          text: "Proceed",
          handler: () => {
            this.dataService
              .deleteRecord(this.assessmentId, this.sectionId, this.id, id)
              .subscribe(() => {
                this.rawData = this.rawData.filter((row) => row.id !== id);
                this.dataRows = this.dataRows.filter((row) => row.id !== id);
                let data = this.dataRows.filter(
                  (row) => row.values["assessmentId"] === this.assessmentId
                );
                if (data.length === 0) {
                  this.newData = false;
                }
                this.updateDataPages();
              });
          },
        },
      ],
    });
    alert.present();
  }

  updateDataPages() {
    this.dataPages = [];

    let dataRows = this.dataRows;
    let pageSize = this.pageSize;
    let dataPages = this.dataPages;
    let pageIndex = -1;
    for (let i = 0; i < dataRows.length; i++) {
      let j = i % pageSize;
      if (j == 0) {
        dataPages.push([]);
        pageIndex++;
      }
      dataPages[pageIndex][j] = dataRows[i];
    }
    if (pageIndex > 0) {
      let endingRow = dataRows.length % pageSize;
      if (endingRow > 0) {
        for (let i = endingRow; i < pageSize; i++) {
          dataPages[pageIndex][i] = this.dummyRow;
        }
      }
    }

    if (this.currentPage > dataRows.length % pageSize) {
      this.prevPage();
    }
  }

  firstPage() {
    if (this.currentPage !== 0) {
      this.currentPage = 0;
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
    }
  }

  setPage(page) {
    if (
      page >= 0 &&
      page <= this.dataPages.length &&
      page !== this.currentPage
    ) {
      this.currentPage = page;
    }
  }

  nextPage() {
    if (this.currentPage < this.dataPages.length - 1) {
      this.currentPage++;
    }
  }

  lastPage() {
    if (this.currentPage !== this.dataPages.length - 1) {
      this.currentPage = this.dataPages.length - 1;
    }
  }

  ngOnDestroy() {
    if (this.cardDepObsSubscription) {
      this.cardDepObsSubscription.unsubscribe();
      this.cardDepObs = null;
    }
  }

  viewMore(row) {
    row.expanded = !row.expanded;
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/new-expandable-list-card/new-expandable-list-card.ts